import Vue from "vue";

export default {
    resetStateMutation(state) {
        Vue.set(state, "countryGridIsOpen", true);
        Vue.set(state, "countryFormIsOpen", false);
        Vue.set(state, "countyGridIsOpen", true);
        Vue.set(state, "countyFormIsOpen", false);
        Vue.set(state, "cityGridIsOpen", true);
        Vue.set(state, "cityFormIsOpen", false);
    },
    openCountryForm(state) {
        state.countryGridIsOpen = false;
        state.countryFormIsOpen = true;
    },
    closeCountryForm(state) {
        state.countryGridIsOpen = true;
        state.countryFormIsOpen = false;
    },
    openCountyForm(state) {
        state.countyGridIsOpen = false;
        state.countyFormIsOpen = true;
    },
    closeCountyForm(state) {
        state.countyGridIsOpen = true;
        state.countyFormIsOpen = false;
    },
    openCityForm(state) {
        state.cityGridIsOpen = false;
        state.cityFormIsOpen = true;
    },
    closeCityForm(state) {
        state.cityGridIsOpen = true;
        state.cityFormIsOpen = false;
    }
}
